import {createStyles, WithStyles} from '@material-ui/core';
import {Theme} from 'feedback-system/with-root/typedef';

export const styles = (theme: Theme) => createStyles({
    pageHeader: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(2)
    },
    userInfo: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    marginClearButton: {
        marginLeft: theme.spacing(2)
    }
});

export type Classes = WithStyles<typeof styles>
